export default __webpack_public_path__ + "static/media/Lovrican-Logo_2.f5a67fe1.svg";